import React, { PureComponent } from "react";
import { Notification, System } from "react-notification-system";

import { cleanErrorMessage, NotificationModel } from "../utils";
import styleOverrides from "./styleOverrides";

const NotificationSystem = require("react-notification-system");

export interface NotificationsViewDispatchProps { }
export interface NotificationsViewOwnProps { }
export interface NotificationsViewStateProps {
    notification: NotificationModel;
}
export type NotificationsViewProps = NotificationsViewDispatchProps &
    NotificationsViewOwnProps &
    NotificationsViewStateProps;

interface NotificationViewState { }

export class NotificationsView extends PureComponent<NotificationsViewProps, NotificationViewState> {
    public ref: System;

    constructor(props: NotificationsViewProps) {
        super(props);

        this.setRef = this.setRef.bind(this);
    }

    componentWillReceiveProps(newProps: NotificationsViewProps) {
        if (newProps.notification) {
            this.handleAddNotification(newProps.notification);
        }
    }

    handleAddNotification(notification: NotificationModel) {
        let notificationConfig: Notification = {
            level: "success",
            message: notification.message,
            title: "Success"
        };

        if (notification.isError) {
            notificationConfig = {
                autoDismiss: 0,
                level: "error",
                message: cleanErrorMessage(notification.message),
                title: "Error"
            };

            console.error(notification.message);
        }

        this.ref.addNotification(notificationConfig);
    }

    render() {
        return <NotificationSystem ref={this.setRef} style={styleOverrides} />;
    }

    setRef(node: System) {
        this.ref = node;
    }
}
